// extracted by mini-css-extract-plugin
export default {"innerWrapper":"jA-z","tooltipWrapper":"kA-z","icon":"lA-z","tooltip":"mA-z","content":"nA-z"};